var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16C1 7.71573 7.71573 1 16 1C16.336 1 16.6695 1.01105 17 1.0328V0.030742C16.6693 0.0103478 16.3358 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16H31Z",
    fill: "#D91F05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.088 19.04C20.088 20.592 18.92 21.936 16.376 22.08V23.92H15.576V22.096C14.008 22.016 12.536 21.44 11.752 20.64L12.216 19.728C12.952 20.448 14.232 20.992 15.576 21.072V16.864C13.816 16.432 12.024 15.888 12.024 13.776C12.024 12.24 13.128 10.912 15.576 10.72V8.88H16.376V10.704C17.576 10.752 18.776 11.104 19.624 11.696L19.224 12.64C18.328 12.064 17.304 11.76 16.376 11.712V15.952C18.184 16.384 20.088 16.896 20.088 19.04ZM13.192 13.744C13.192 14.96 14.264 15.408 15.576 15.744V11.744C13.928 11.888 13.192 12.736 13.192 13.744ZM16.376 21.072C18.136 20.944 18.92 20.128 18.92 19.104C18.92 17.84 17.752 17.408 16.376 17.072V21.072Z",
    fill: "#D91F05"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.e0e6fb60e0748de5ae8830250e68a257.svg";
export { ForwardRef as ReactComponent };